import createVueApp from '@/common/createApp'

Styxie.Initializers.AdminMomentsMobileBusinesses = {
  show: async(props) => {
    const { default: ShowPage } = await import('@/vue_widgets/admin/moments/mobile_businesses/show.vue')
    createVueApp(ShowPage, { props })
  }
}
